import { render, staticRenderFns } from "./SizePalette.vue?vue&type=template&id=70ab79c5&scoped=true&"
import script from "./SizePalette.vue?vue&type=script&lang=js&"
export * from "./SizePalette.vue?vue&type=script&lang=js&"
import style0 from "./SizePalette.vue?vue&type=style&index=0&id=70ab79c5&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ab79c5",
  null
  
)

export default component.exports